import qs from 'query-string';
import SuperFetchV2 from '../../superFetchV2';
import { AlimtalkTemplate, AlimtalkTemplateListResponse } from '../../../types/alimtalk/template';
import {
  AlimtalkCsvSampleResponse,
  AlimtalkSendResponse,
  AlimtalkUploadUrlResponse,
  CreateAlimtalkSendDto,
  PreviewAlimtalkSendResponse,
  TestAlimtalkSendDto,
} from '../../../types/alimtalk/send';

// SuperFetchV2 baseURL은 이미 `${VITE_API_URL_NESTJS}/api` 이므로 경로는 `/alimtalk-*` 로 시작.
// 응답 형태 정본: 백엔드 alimtalk-send/alimtalk-template 컨트롤러 (2xx는 DTO 그대로, 4xx는 {status,timestamp,errors[]})
export const AlimtalkApiV2 = {
  /** 발송 유형(템플릿) 목록 — 응답은 { templates } 래핑, 활성 필터는 activeOnly */
  getTemplateList: (params?: { activeOnly?: boolean }): Promise<AlimtalkTemplateListResponse> => {
    const queryString = qs.stringify(params ?? {}, { skipNull: true });
    return SuperFetchV2.get(`/alimtalk-templates${queryString ? `?${queryString}` : ''}`);
  },

  /** 템플릿 상세 */
  getTemplateDetail: (id: number): Promise<AlimtalkTemplate> =>
    SuperFetchV2.get(`/alimtalk-templates/${id}`),

  /** 샘플 CSV 헤더 — CSV 모드 전용(그 외 400). 파일 생성은 클라이언트 Blob */
  getCsvSample: (templateId: number): Promise<AlimtalkCsvSampleResponse> =>
    SuperFetchV2.get(`/alimtalk-templates/${templateId}/csv-sample`),

  /** CSV S3 presigned PUT URL 발급 (요청 body 없음, ContentType: text/csv 고정) */
  getUploadUrl: (): Promise<AlimtalkUploadUrlResponse> =>
    SuperFetchV2.post('/alimtalk-sends/upload-url'),

  /** dry-run — CSV 파싱 + dedupe + 1행 메시지 미리보기 (권한: alimtalkSendSchedule.read) */
  previewSend: (dto: CreateAlimtalkSendDto): Promise<PreviewAlimtalkSendResponse> =>
    SuperFetchV2.post('/alimtalk-sends/preview', dto),

  /** 스케줄 등록 (즉시 or 예약) */
  createSend: (dto: CreateAlimtalkSendDto): Promise<AlimtalkSendResponse> =>
    SuperFetchV2.post('/alimtalk-sends', dto),

  /** 테스트 발송 (testPhone 1건, 쿠폰 INSERT 없음 — DTO는 등록과 동일 전체 검증) */
  testSend: (dto: TestAlimtalkSendDto): Promise<AlimtalkSendResponse> =>
    SuperFetchV2.post('/alimtalk-sends/test', dto),
};
